import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  removeAndContinue: {
    description: 'batchProcessingModal.removeAndContinue',
    defaultMessage: 'Remove and Continue',
    id: 'x7vPMI',
  },
  continue: {
    description: 'batchProcessingModal.continue',
    defaultMessage: 'Continue',
    id: '1MIE4W',
  },
  errorsAndWarningsTitle: {
    description: 'batchProcessingModal.errorsAndWarningsTitle',
    defaultMessage: 'Errors and Warnings',
    id: '+KE04c',
  },
  instructions: {
    description: 'batchProcessingModal.instructions',
    defaultMessage: 'Resolve or ignore errors on shipments before creating labels.',
    id: 'MmElt+',
  },
  bulkRemove: {
    description: 'batchProccesingModal.bulkRemove',
    defaultMessage: 'Remove Selected',
    id: '8TL7bT',
  },
  cancel: {
    description: 'batchProcessingModal.cancel',
    defaultMessage: 'Cancel',
    id: 'HnnngW',
  },
});
